import { Action, Method, NO_VALUE } from './constants.js';
export const buildModalViewDisplayedPayload = (buildModalViewDisplayedParams) => {
    const { componentTitle, loginSource, componentState } = buildModalViewDisplayedParams;
    const trackingPayload = {
        method: Method.LINK,
        triggeringEventPlace: {
            componentId: componentTitle,
            linkName: 'componentVisible',
        },
        trackingData: {
            eventName: [NO_VALUE],
            elementActioned: 'component',
            elementAction: Action.VISIBLE,
            elementActionValue: 'noValue',
            loginSource,
            allowLinkBeforeView: true,
            componentState: componentState || NO_VALUE,
        },
    };
    return trackingPayload;
};
//# sourceMappingURL=buildModalViewDisplayedPayload.js.map